import "./DeleteFoodModal.css";
import { MdWarningAmber } from "react-icons/md";

function DeleteFoodModal({
  open,
  food,
  onClose,
  onDelete,
  loading = false,
}) {
  if (!open || !food) return null;

  const handleDelete = () => {
    onDelete(food._id);
  };

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
    >
      <div
        className="delete-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="delete-icon">
          <MdWarningAmber />
        </div>

        <h2>Delete Food?</h2>

        <p>
          Are you sure you want to delete
          <strong> "{food.foodName}" </strong>?
        </p>

        <p className="warning-text">
          This action cannot be undone.
        </p>

        <div className="delete-actions">

          <button
            className="cancel-btn"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            className="delete-btn"
            onClick={handleDelete}
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </button>

        </div>

      </div>
    </div>
  );
}

export default DeleteFoodModal;